import { ProductAnalysisGroup2 } from '../../entities/control-tables/product-analysis-group2-entity';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';

 
export class ProductAnalysisGroup2Request extends BaseRequest {

    productAnalysisGroup2 : ProductAnalysisGroup2

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.productAnalysisGroup2 = new ProductAnalysisGroup2()
  }
}